import { Edit3 } from 'lucide-react';
import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../../lib/messages';
import type { A2vAsset } from '../../model';

interface AssetActionsProps {
  asset: A2vAsset;
  onEdit: (asset: A2vAsset) => void;
}

export function AssetActions({ asset, onEdit }: AssetActionsProps) {
  return (
    <DashboardTableRowActions label={dashboardT('a2v.assets.actions')}>
      <DashboardTableRowActionItem
        onClick={() => {
          onEdit(asset);
        }}
      >
        <Edit3 aria-hidden="true" />
        {dashboardT('a2v.assets.edit.action')}
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
